<template>
  <label :for="context.id">
    {{ context.label }}
    <InfoIcon
        v-if="tooltip"
        class="form-label-info-icon"
        :tooltip="tooltipObject"
    />
  </label>
</template>

<script src="./FormulateLabel.js"></script>